import React, {createContext, useContext } from 'react'


const FormValidationContext = createContext();

const vaidationErrors = {};

const FormValidationContextProvider = ({ children }) => {
    console.log('FormValidationContextProvider().Entry vaidationErrors=', JSON.stringify(vaidationErrors));
    return (
      <FormValidationContext.Provider value={{vaidationErrors}}>
        {children}
      </FormValidationContext.Provider>
    );
};

const useFormValidatonContext = () => {
    return useContext(FormValidationContext);
  };

export default FormValidationContextProvider;
export { useFormValidatonContext }    ;
